import styles from "./VendorDepositSaveBar.module.css";

// Bar mengambang di bawah layar: jumlah deposit yang diubah + simpan/batal sekaligus
const VendorDepositSaveBar = ({ count, saving, onSave, onCancel }) => (
  <div className={styles.bar} role="status">
    <span>
      <span className={styles.count}>{count}</span>
      data deposit diubah, belum disimpan
    </span>
    <div className={styles.actions}>
      <button type="button" className="btn btn-outline-dark btn-sm" onClick={onCancel} disabled={saving}>
        Batal
      </button>
      <button type="button" className="btn btn-primary btn-sm" onClick={onSave} disabled={saving}>
        {saving ? (
          <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        ) : (
          <i className="fa fa-save me-1"></i>
        )}
        Simpan
      </button>
    </div>
  </div>
);

export default VendorDepositSaveBar;
